import { render } from "./IconView.vue?vue&type=template&id=113be7fe&scoped=true"
import script from "./IconView.vue?vue&type=script&lang=js"
export * from "./IconView.vue?vue&type=script&lang=js"

import "./IconView.vue?vue&type=style&index=0&id=113be7fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113be7fe"]])

export default __exports__